/* eslint-disable no-unused-vars */
import TicketSelect from "./TicketSelect";

// A floating leg in a currency with no seeded reference rates cannot be sent (the API
// rejects every rate), so say why rather than showing an empty dropdown. Q25.

interface IReferenceRateSelect {
  value: string;
  options: string[];
  currency: string;
  onChange: (referenceRate: string) => void;
  testId: string;
}

export function returnNoReferenceRateMessage(currency: string): string {
  return `No reference rates for ${currency || "this currency"}`;
}

const ReferenceRateSelect = ({
  value,
  options,
  currency,
  onChange,
  testId,
}: IReferenceRateSelect) => {
  if (options.length === 0) {
    return (
      <div
        data-testid={testId}
        id={testId}
        className="px-1 text-xs text-amber-600 dark:text-amber-400"
      >
        {returnNoReferenceRateMessage(currency)}
      </div>
    );
  }
  return (
    <TicketSelect<string>
      testId={testId}
      value={value}
      options={options}
      includeEmptyOption={false}
      onChange={onChange}
    />
  );
};

export default ReferenceRateSelect;
